import { OnInit, Input, ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { LetterOnBoard } from '@schoolbelle/api/letter-to-board';
import { GroupService } from '@schoolbelle/api/group';
import { BoardService } from '@schoolbelle/api/board';
import { BadgeService } from '@schoolbelle/api/badge';

@Component({
  selector: 'app-letter-metadata',
  templateUrl: './letter-metadata.component.html',
  styleUrls: ['./letter-metadata.component.css']
})
export class LetterMetadataComponent implements OnInit {
  @Input() item:LetterOnBoard;
  @Input() posted_at:boolean = false;
  @Output() onCommentClick = new EventEmitter();
  @Output() onReadClick = new EventEmitter();

  constructor(
    public group:GroupService,
    public board:BoardService,
    protected badge:BadgeService,
    protected cdRef:ChangeDetectorRef,
  ) { }

  ngOnInit() {
  }
  get isCommentNew ():boolean {
    const ltg_id:number = this.item && this.item.ltg_id;
    return (
      ltg_id 
      && this.badge.find({'action':'comment.insert', 'new.ltg_id' : ltg_id, 'read':0})
    )? true : false;
  }
  openCommentModal () {
    this.onCommentClick.next(null);
  }   
  openReadListModal (item:LetterOnBoard) {
    this.onReadClick.next(null);
  }


}
